import { useCallback } from 'react';
import { useRxData } from 'rxdb-hooks';

import { Discipline } from '../../models/models';
import { RxdbCollectionName } from '../rxdbCollectionName';
import type { RemedialAction, RemedialActionCollection } from './remedialAction.types';

const useRemedialAction = (disciplineId: number) => {
  const discipline = disciplineId === Discipline.Shaft ? Discipline.Structural : disciplineId;
  const getRemedialActionQuery = useCallback(
    (collection: RemedialActionCollection) => {
      return collection?.find({ selector: { discipline } });
    },
    [discipline],
  );

  const { result: remedialActionListData } = useRxData<RemedialAction>(
    RxdbCollectionName.REMEDIAL_ACTION,
    getRemedialActionQuery,
    { json: true },
  );

  return { remedialActionListData };
};

export default useRemedialAction;
